exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.submit-images-main .button--remove {\n  font-family: 'Bureau Grot Bk', helvetica;\n  font-weight: 400;\n  font-size: 12px;\n  letter-spacing: 0.3px;\n  line-height: 1;\n  text-transform: uppercase;\n  margin: 0 12px 0 6px;\n  vertical-align: middle;\n  color: #000 !important;\n  background-color: #eae5db !important;\n}\n", ""]);

// exports
